import React, { Component } from 'react';
import b from 'b_';
import { AuthPage, AuthBox } from './AuthLayout';
import { FTBody, FTHeadline } from '../Fuse';
import FuseButton from '../FuseControls/FuseButton';
import './LoginFailureSSO.css';

const block = b.lock('LoginFailureSSO');

class LoginFailureSso extends Component {
    onSubmit = (event) => {
        event.preventDefault();
        window.location = '/console/index';
    };

    render() {
        return (
            <AuthPage>
                <AuthBox onSubmit={this.onSubmit}>
                    <FTHeadline className={block('MarginBottom')}>
                        SSO Login Failure
                    </FTHeadline>
                    <FTBody className={block('MarginBottom', { section: 'textBody' })}>
                        Unable to process this login request, please
                        <br />
                        reach out to your company’s support team.
                    </FTBody>
                    <FuseButton
                        submit
                        type={'primary'}
                        color={'blue'}
                        fullWidth
                        onClick={this.onSubmit}
                    >Back to Login</FuseButton>
                </AuthBox>
            </AuthPage>
        );
    }
}

export default LoginFailureSso;
